export type CMSReferralRewardPointDTO = {
  id: number;
  attributes: {
    referree_multiplier: number;
    referrer_multiplier: number;
    duration: number;
    threshold_points: number;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  };
};

export type CMSDefiAddressWhitelistDTO = {
  id: number;
  attributes: {
    defi_address_whitelist: {
      defi_address_whitelist: string[];
    };
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  };
};

export * from "./cmsGlobal";
export * from "./trade-to-earn";
